import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { PERMISSIONS, resolveErpPermissionCode } from "../utils/permissions";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import Pagination from "../components/Pagination";
import "./EmployeePermissionPanel.css";

const P = PERMISSIONS;

export const PERMISSION_CATALOG = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "solar:widget-2-linear",
    items: [
      {
        id: "dashboard",
        label: "Dashboard",
        // hint: "Home overview and widgets",
        view: [P.DASHBOARD_VIEW],
      },
    ],
  },
  {
    id: "walkins",
    label: "Walk-Ins & Counter",
    icon: "solar:users-group-rounded-linear",
    items: [
      {
        id: "walkins",
        label: "Walk-Ins",
        // hint: "Customer arrival desk",
        add: [P.WALKIN_ADD],
      },
      {
        id: "customer-assign",
        label: "Customer Assign",
        // hint: "Assign walk-ins to staff",
        view: [P.CUSTOMER_ASSIGN_VIEW],
      },
      {
        id: "order-queue",
        label: "Order Queue",
        // hint: "Work queue for open orders",
        view: [P.ORDER_QUEUE_VIEW],
      },
    ],
  },
  {
    id: "hrms",
    label: "HRMS",
    icon: "solar:case-linear",
    items: [
      {
        id: "hrms-holidays",
        label: "Holidays",
        // hint: "Holiday calendar",
        view: [P.HRMS_HOLIDAY_VIEW],
        add: [P.HRMS_HOLIDAY_ADD],
        edit: [P.HRMS_HOLIDAY_EDIT],
      },
      {
        id: "hrms-profiles",
        label: "Payroll Profiles",
        // hint: "Employee payroll setup",
        view: [P.HRMS_PROFILE_VIEW],
        add: [P.HRMS_PROFILE_ADD],
        edit: [P.HRMS_PROFILE_EDIT],
      },
      {
        id: "hrms-attendance",
        label: "Attendance",
        // hint: "Daily attendance records",
        view: [P.HRMS_ATTENDANCE_VIEW],
        add: [P.HRMS_ATTENDANCE_ADD],
      },
      {
        id: "hrms-incentives",
        label: "Incentives",
        // hint: "Incentive entries and approvals",
        view: [P.HRMS_INCENTIVE_VIEW],
        add: [P.HRMS_INCENTIVE_ADD],
        edit: [P.HRMS_INCENTIVE_EDIT],
      },
      {
        id: "hrms-overtime",
        label: "Overtime",
        // hint: "Overtime management and approvals",
        view: [P.HRMS_OVERTIME_VIEW],
        add: [P.HRMS_OVERTIME_ADD],
        edit: [P.HRMS_OVERTIME_EDIT],
      },
      {
        id: "hrms-advance",
        label: "Salary Advance",
        // hint: "Advance requests and tracking",
        view: [P.HRMS_ADVANCE_VIEW],
        add: [P.HRMS_ADVANCE_ADD],
        edit: [P.HRMS_ADVANCE_EDIT],
      },
      {
        id: "hrms-payroll",
        label: "Payroll",
        // hint: "Payroll run and lock",
        view: [P.HRMS_PAYROLL_VIEW],
        add: [P.HRMS_PAYROLL_ADD],
        edit: [P.HRMS_PAYROLL_EDIT],
      },
    ],
  },
  {
    id: "sales-targets",
    label: "Sales Targets",
    icon: "solar:graph-up-linear",
    items: [
      {
        id: "sales-target",
        label: "Sales Target",
        // hint: "Branch and staff sales targets",
        view: [P.SALES_TARGET_VIEW],
        add: [P.SALES_TARGET_ADD],
        edit: [P.SALES_TARGET_EDIT],
      },
    ],
  },
  {
    id: "orders",
    label: "Orders & Transactions",
    icon: "solar:bag-3-linear",
    items: [
      {
        id: "sales-invoice",
        label: "Sales / Invoice",
        // hint: "Sales bills and tax invoices",
        view: [P.SALES_VIEW],
        add: [P.SALES_ADD],
        edit: [P.SALES_EDIT],
        remove: [P.SALES_DELETE],
      },
      {
        id: "wholesale-invoice",
        label: "Wholesale",
        // ERP: WHSALE_ADD(169) WHSALE_EDIT(170) WHSALE_VIEW(171) WHSALE_DELETE(172)
        view: [P.WHSALE_VIEW],
        add: [P.WHSALE_ADD],
        edit: [P.WHSALE_EDIT],
        remove: [P.WHSALE_DELETE],
      },
      {
        id: "sales-gst-portal",
        label: "Sales GST Portal",
        // hint: "GST portal sync and e-invoicing",
        view: [P.SALES_GST_PORTAL_ADD],
        add: [P.SALES_GST_PORTAL_ADD],
      },
      {
        id: "purchase",
        label: "Purchase",
        // hint: "Purchase bills and table",
        view: [P.PURCHASE_VIEW],
        add: [P.PURCHASE_ADD],
        edit: [P.PURCHASE_EDIT],
      },
      {
        id: "ratecut",
        label: "Rate Cut",
        // hint: "Fix metal purchase rate cuts",
        view: [P.RATECUT_VIEW, P.RATECUT_view],
        add: [P.RATECUT_ADD],
        edit: [P.RATECUT_EDIT],
      },
      {
        id: "old-metal-purchase",
        label: "Old Metal Purchase",
        // hint: "URD / old gold & silver purchase",
        view: [P.OLD_METAL_PURCHASE_VIEW],
        add: [P.OLD_METAL_PURCHASE_ADD],
        edit: [P.OLD_METAL_PURCHASE_EDIT],
      },
      {
        id: "custom-order",
        label: "Custom Order",
        // hint: "Made-to-order customer orders",
        view: [P.CUSTOM_ORDER_VIEW],
        add: [P.CUSTOM_ORDER_ADD],
        edit: [P.CUSTOM_ORDER_EDIT],
      },
      {
        id: "repairing-order",
        label: "Repairing Order",
        // hint: "Customer jewellery repairing tickets",
        view: [P.REPAIRING_ORDER_VIEW],
        add: [P.REPAIRING_ORDER_ADD],
        edit: [P.REPAIRING_ORDER_EDIT],
      },
      {
        id: "jangad",
        label: "Jangad",
        // hint: "Approval issue / return slips",
        view: [P.JANGAD_VIEW],
        add: [P.JANGAD_ADD],
        edit: [P.JANGAD_EDIT],
      },
      {
        id: "refinery",
        label: "Refinery",
        // hint: "Metal refining transactions",
        view: [P.REFINERY_VIEW],
        add: [P.REFINERY_ADD],
        edit: [P.REFINERY_EDIT],
      },
      {
        id: "metal-transfer",
        label: "Metal Transfer",
        // hint: "Inter-branch or counter metal transfer",
        view: [P.METAL_TRANSFER_VIEW],
      },
      {
        id: "other-charge",
        label: "Other Charge",
        // hint: "Invoice & order additional charges",
        view: [P.OTHER_CHARGE_VIEW],
        add: [P.OTHER_CHARGE_ADD],
        edit: [P.OTHER_CHARGE_EDIT],
      },
    ],
  },
  {
    id: "products",
    label: "Products & Stock",
    icon: "solar:box-linear",
    items: [
      {
        id: "products-stock",
        label: "Stock / Products",
        // hint: "Stock inventory, barcode tagging and bulk items",
        view: [P.PRODUCT_VIEW],
        add: [P.PRODUCT_ADD],
        edit: [P.PRODUCT_EDIT],
      },
      {
        id: "stock-check",
        label: "Stock Check",
        // hint: "Physical stock audit and verification",
        view: [P.STOCK_CHECK_VIEW],
      },
      {
        id: "product-search",
        label: "Product Search",
        // hint: "Fast catalog search & lookup",
        view: [P.PRODUCT_SEARCH_VIEW],
      },
    ],
  },
  {
    id: "party",
    label: "Party & Contacts",
    icon: "solar:user-id-linear",
    items: [
      {
        id: "customer",
        label: "Customer",
        // hint: "Customer master records",
        view: [P.CUSTOMER_VIEW],
        add: [P.CUSTOMER_ADD],
        edit: [P.CUSTOMER_EDIT],
      },
      {
        id: "customer-settlement",
        label: "Customer Settlement",
        // hint: "Customer payment & metal settlements",
        view: [P.CUSTOMER_SETTLEMENT_VIEW],
        add: [P.CUSTOMER_SETTLEMENT_ADD],
        edit: [P.CUSTOMER_SETTLEMENT_EDIT],
      },
      {
        id: "supplier",
        label: "Supplier / Karigar",
        // hint: "Supplier & artisan accounts",
        view: [P.SUPPLIER_VIEW],
        add: [P.SUPPLIER_ADD],
        edit: [P.SUPPLIER_EDIT],
      },
      {
        id: "supplier-settlement",
        label: "Supplier Settlement",
        // hint: "Karigar and supplier payment settlement",
        view: [P.SUPPLIER_SETTLEMENT_VIEW],
        add: [P.SUPPLIER_SETTLEMENT_ADD],
        edit: [P.SUPPLIER_SETTLEMENT_EDIT],
      },
      {
        id: "karigar-conversion",
        label: "Karigar Conversion",
        // hint: "Metal to jewellery conversion slips",
        view: [P.KARIGAR_CONVERSION_VIEW],
        add: [P.KARIGAR_CONVERSION_ADD],
        edit: [P.KARIGAR_CONVERSION_EDIT],
      },
    ],
  },
  {
    id: "item-groups",
    label: "Item Groups & Classification",
    icon: "solar:layers-linear",
    items: [
      {
        id: "metal-group",
        label: "Metal Group",
        // hint: "Gold, Silver, Platinum metals",
        view: [P.METAL_GROUP_VIEW],
        add: [P.METAL_GROUP_ADD],
        edit: [P.METAL_GROUP_EDIT],
      },
      {
        id: "item-category",
        label: "Item Category",
        // hint: "Ring, Necklace, Bangle categories",
        view: [P.ITEM_CATEGORY_VIEW],
        add: [P.ITEM_CATEGORY_ADD],
        edit: [P.ITEM_CATEGORY_EDIT],
      },
      {
        id: "product-group",
        label: "Product Group",
        // hint: "Groupings and design lines",
        view: [P.PRODUCT_GROUP_VIEW],
        add: [P.PRODUCT_GROUP_ADD],
        edit: [P.PRODUCT_GROUP_EDIT],
      },
      {
        id: "product-assorting",
        label: "Product Assorting",
        // hint: "Stone, diamond and purity assorting",
        view: [P.PRODUCT_ASSORTING_VIEW],
        add: [P.PRODUCT_ASSORTING_ADD],
        edit: [P.PRODUCT_ASSORTING_EDIT],
      },
    ],
  },
  {
    id: "shop-expense",
    label: "Shop Expense",
    icon: "solar:wallet-money-linear",
    items: [
      {
        id: "shop-expense",
        label: "Shop Expense",
        // hint: "Daily operating overheads & bills",
        view: [P.SHOP_EXPENSE_TABLE],
        add: [P.ADD_SHOP_EXPENSE],
        edit: [P.EDIT_SHOP_EXPENSE],
      },
    ],
  },
  {
    id: "setup",
    label: "Setup & Masters",
    icon: "solar:settings-linear",
    items: [
      {
        id: "daily-price",
        label: "Daily Price",
        // hint: "Gold, silver, and metal rate board",
        view: [P.DAILY_PRICE_VIEW],
        add: [P.DAILY_PRICE_ADD],
      },
      {
        id: "bank",
        label: "Bank Master",
        // hint: "Company bank accounts and details",
        view: [P.BANK_VIEW],
        add: [P.BANK_ADD],
        edit: [P.BANK_EDIT],
      },
      {
        id: "cash-bank",
        label: "Cash & Bank Entry",
        // hint: "Cashbook & bankbook ledger vouchers",
        view: [P.CASH_BANK_VIEW],
        add: [P.CASH_BANK_ADD],
        edit: [P.CASH_BANK_EDIT],
      },
      {
        id: "capital-investment",
        label: "Capital Investment",
        // hint: "Partner capital entries and history",
        view: [P.CAPITAL_INVESTMENT_VIEW],
        add: [P.CAPITAL_INVESTMENT_ADD],
        edit: [P.CAPITAL_INVESTMENT_EDIT],
      },
      {
        id: "tenant",
        label: "Tenant",
        // hint: "Tenant organisation details",
        view: [P.TENANT_VIEW],
        add: [P.TENANT_ADD],
        edit: [P.TENANT_EDIT],
      },
      {
        id: "branch",
        label: "Branch",
        // hint: "Store branches and showrooms",
        view: [P.BRANCH_VIEW],
        add: [P.BRANCH_ADD],
        edit: [P.BRANCH_EDIT],
      },
      {
        id: "role",
        label: "Role",
        // hint: "Staff access roles and permission templates",
        view: [P.ROLE_VIEW],
        add: [P.ROLE_ADD],
        edit: [P.ROLE_EDIT],
      },
      {
        id: "employee",
        label: "Employee",
        // hint: "Staff user profiles and branch access",
        // EMPLOYEE_ADD is not a valid ERP permission_code — use VIEW + EDIT only.
        view: [P.EMPLOYEE_VIEW],
        edit: [P.EMPLOYEE_EDIT],
      },
    ],
  },
  {
    id: "dihran",
    label: "Girvi / Dihran",
    icon: "solar:safe-2-linear",
    items: [
      {
        id: "girvi-dashboard",
        label: "Girvi Dashboard",
        // hint: "Pawn loan analytics and summary",
        view: [P.GIRVI_DASHBOARD_VIEW],
      },
      {
        id: "girvi-dihran",
        label: "Girvi / Dihran",
        // hint: "Pawn contracts, pledged items, loans",
        view: [P.GIRVI_VIEW],
        add: [P.GIRVI_ADD],
        edit: [P.GIRVI_EDIT],
      },
      {
        id: "girvi-payment",
        label: "Quick Payment",
        // hint: "Fast interest payment vouchers",
        view: [P.GIRVI_QUICK_PAYMENT_VIEW],
      },
      {
        id: "girvi-bank",
        label: "Girvi Bank Details",
        // hint: "Financier bank accounts and tie-ups",
        view: [P.GIRVI_BANK_VIEW],
        add: [P.GIRVI_BANK_ADD],
        edit: [P.GIRVI_BANK_EDIT],
      },
      {
        id: "girvi-ledger",
        label: "Girvi Bank Ledger",
        // hint: "Financier loan ledgers & interest",
        view: [P.GIRVI_BANK_LEDGER_VIEW],
      },
      {
        id: "reverse-girvi-dashboard",
        label: "Reverse Girvi Dashboard",
        view: [P.REVERSE_GIRVI_DASHBOARD_VIEW],
      },
      {
        id: "reverse-girvi",
        label: "Reverse Girvi / Reverse Dihran",
        view: [P.REVERSE_GIRVI_VIEW],
        add: [P.REVERSE_GIRVI_ADD],
        edit: [P.REVERSE_GIRVI_EDIT],
      },
      {
        id: "reverse-girvi-payment",
        label: "Pay to Customer",
        view: [P.REVERSE_GIRVI_QUICK_PAYMENT_VIEW],
      },
    ],
  },
  {
    id: "reports",
    label: "Reports & Ledgers",
    icon: "solar:document-text-linear",
    items: [
      {
        id: "overall-ledger",
        label: "Overall Ledger",
        // hint: "General ledger view",
        view: [P.OVERALL_LEDGER],
      },
      {
        id: "rojmel",
        label: "Rojmel",
        // hint: "Daily cashbook (day book)",
        view: [P.ROJMEL_VIEW],
      },
      {
        id: "bank-ledger",
        label: "Bank Ledger",
        // hint: "Bank statement register",
        view: [P.BANK_LEDGER],
      },
      {
        id: "karigar-ledger",
        label: "Karigar Ledger",
        // hint: "Artisan gold & silver balance",
        view: [P.KARIGAR_LEDGER],
      },
      {
        id: "customer-ledger",
        label: "Customer Ledger",
        // hint: "Customer outstanding register",
        view: [P.CUSTOMER_LEDGER],
      },
      {
        id: "purchase-ledger",
        label: "Purchase Ledger",
        // hint: "Purchase accounts register",
        view: [P.PURCHASE_LEDGER],
      },
      {
        id: "sales-ledger",
        label: "Sales Ledger",
        // hint: "Sales accounts register",
        view: [P.SALES_LEDGER],
      },
      {
        id: "urd-ledger",
        label: "URD Ledger",
        // hint: "Unregistered purchase ledger",
        view: [P.URD_LEDGER],
      },
    ],
  },
  {
    id: "leads-reminders",
    label: "Leads & Reminders",
    icon: "solar:bell-linear",
    items: [
      {
        id: "leads",
        label: "Leads",
        // hint: "Prospective customer leads",
        view: [P.LEADS_VIEW],
        add: [P.LEADS_ADD],
        edit: [P.LEADS_EDIT],
      },
      {
        id: "reminders",
        label: "Reminders",
        // hint: "Follow-up tasks and customer alerts",
        view: [P.REMINDERS_VIEW],
      },
    ],
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    icon: "solar:chat-round-linear",
    items: [
      {
        id: "whatsapp-dashboard",
        label: "WhatsApp Dashboard",
        // hint: "Messaging analytics and delivery stats",
        view: [P.WHATSAPP_DASHBOARD],
      },
      {
        id: "whatsapp-inbox",
        label: "WhatsApp Inbox",
        // hint: "Live customer chat inbox",
        view: [P.WHATSAPP_INBOX],
      },
      {
        id: "whatsapp-campaign",
        label: "WhatsApp Campaign",
        // hint: "Broadcast messaging campaigns",
        view: [P.WHATSAPP_CAMPAIGN],
        add: [P.WHATSAPP_CAMPAIGN_ADD],
      },
      {
        id: "whatsapp-template",
        label: "WhatsApp Template",
        // hint: "Approved HSM chat templates",
        view: [P.WHATSAPP_TEMPLATE],
        add: [P.WHATSAPP_TEMPLATE_ADD],
      },
      {
        id: "whatsapp-phonebook",
        label: "WhatsApp Phonebook",
        // hint: "Contact lists and group segments",
        view: [P.WHATSAPP_PHONEBOOK],
        add: [P.WHATSAPP_PHONEBOOK_ADD],
      },
    ],
  },
  {
    id: "scheme",
    label: "Scheme",
    icon: "solar:gift-linear",
    items: [
      {
        id: "scheme-plan",
        label: "Scheme Plan",
        // hint: "Gold savings scheme definitions",
        view: [P.SCHEME_PLAN_VIEW],
        add: [P.SCHEME_PLAN_ADD],
        edit: [P.SCHEME_PLAN_EDIT],
      },
      {
        id: "scheme",
        label: "Customer Scheme",
        // hint: "Enrolled customer cards & transactions",
        view: [P.SCHEME_VIEW],
        add: [P.SCHEME_ADD],
        edit: [P.SCHEME_EDIT],
      },
    ],
  },
];

/** Set of all uppercase ERP codes defined in the catalog */
export const KNOWN_CATALOG_CODES = (() => {
  const codes = new Set();
  PERMISSION_CATALOG.forEach((cat) => {
    (cat.items || []).forEach((item) => {
      (item.view || []).forEach((c) => {
        const code = resolveErpPermissionCode(c);
        if (code) codes.add(code);
      });
      (item.add || []).forEach((c) => {
        const code = resolveErpPermissionCode(c);
        if (code) codes.add(code);
      });
      (item.edit || []).forEach((c) => {
        const code = resolveErpPermissionCode(c);
        if (code) codes.add(code);
      });
      (item.remove || []).forEach((c) => {
        const code = resolveErpPermissionCode(c);
        if (code) codes.add(code);
      });
    });
  });
  return codes;
})();

function getItemAccess(permissions, item) {
  const hasView = Boolean(item.view?.length);
  const hasAdd = Boolean(item.add?.length);
  const hasEdit = Boolean(item.edit?.length);
  const hasDelete = Boolean(item.remove?.length);

  return {
    hasView,
    hasAdd,
    hasEdit,
    hasDelete,
    view: hasView ? item.view.some((key) => Boolean(permissions[key])) : false,
    add: hasAdd ? item.add.some((key) => Boolean(permissions[key])) : false,
    edit: hasEdit ? item.edit.some((key) => Boolean(permissions[key])) : false,
    delete: hasDelete
      ? item.remove.some((key) => Boolean(permissions[key]))
      : false,
  };
}

function setPermissionKeys(permissions, keys, value) {
  if (!keys || !keys.length) return permissions;
  const next = { ...permissions };
  keys.forEach((key) => {
    next[key] = value;
  });
  if (keys.includes(P.SUPPLIER_VIEW) || keys.includes(P.SUPPLIER)) {
    next[P.SUPPLIER] = value;
    next[P.KARIGAR] = value;
  }
  if (keys.includes(P.RATECUT_VIEW) || keys.includes(P.RATECUT_view)) {
    next[P.RATECUT_VIEW] = value;
    next[P.RATECUT_view] = value;
  }
  return next;
}

function toggleItemAccess(permissions, item, flag) {
  const current = getItemAccess(permissions, item);
  const nextVal = !current[flag];
  let nextPerms = permissions;

  if (flag === "view") {
    nextPerms = setPermissionKeys(permissions, item.view || [], nextVal);
    // If turning view OFF, also turn add, edit and delete OFF
    if (!nextVal) {
      if (item.add?.length) {
        nextPerms = setPermissionKeys(nextPerms, item.add, false);
      }
      if (item.edit?.length) {
        nextPerms = setPermissionKeys(nextPerms, item.edit, false);
      }
      if (item.remove?.length) {
        nextPerms = setPermissionKeys(nextPerms, item.remove, false);
      }
    }
  } else if (flag === "add") {
    nextPerms = setPermissionKeys(permissions, item.add || [], nextVal);
    // If turning add ON, also ensure view is ON
    if (nextVal && item.view?.length) {
      nextPerms = setPermissionKeys(nextPerms, item.view, true);
    }
  } else if (flag === "edit") {
    nextPerms = setPermissionKeys(permissions, item.edit || [], nextVal);
    // If turning edit ON, also ensure view is ON
    if (nextVal && item.view?.length) {
      nextPerms = setPermissionKeys(nextPerms, item.view, true);
    }
  } else if (flag === "delete") {
    nextPerms = setPermissionKeys(permissions, item.remove || [], nextVal);
    // If turning delete ON, also ensure view is ON
    if (nextVal && item.view?.length) {
      nextPerms = setPermissionKeys(nextPerms, item.view, true);
    }
  }

  return nextPerms;
}

function setItemAllAccess(permissions, item, nextVal) {
  let nextPerms = permissions;
  if (item.view?.length) {
    nextPerms = setPermissionKeys(nextPerms, item.view, nextVal);
  }
  if (item.add?.length) {
    nextPerms = setPermissionKeys(nextPerms, item.add, nextVal);
  }
  if (item.edit?.length) {
    nextPerms = setPermissionKeys(nextPerms, item.edit, nextVal);
  }
  if (item.remove?.length) {
    nextPerms = setPermissionKeys(nextPerms, item.remove, nextVal);
  }
  return nextPerms;
}

function isRowAllOn(permissions, item) {
  const access = getItemAccess(permissions, item);
  return (
    (!access.hasView || access.view) &&
    (!access.hasAdd || access.add) &&
    (!access.hasEdit || access.edit) &&
    (!access.hasDelete || access.delete)
  );
}

function AccessCheckbox({ id, checked, disabled, label, caption, onChange }) {
  return (
    <Form.Check
      type="checkbox"
      id={id}
      className="emp-perm-check mb-0"
      checked={checked}
      disabled={disabled}
      label={caption}
      aria-label={label}
      onChange={onChange}
    />
  );
}

function EmployeePermissionPanel({ permissions, disabled = false, onChange }) {
  const { tableClass, cardClass, buttonTableStyle } = useButtonTableStyle();
  const [query, setQuery] = useState("");

  const filteredItems = useMemo(() => {
    const q = query.trim().toLowerCase();
    const items = PERMISSION_CATALOG.flatMap((category) => {
      return category.items.map((item) => ({
        ...item,
        categoryId: category.id,
        pageLabel: item.label,
        groupLabel: category.label,
      }));
    });
    if (!q) return items;
    return items.filter(
      (item) =>
        item.pageLabel.toLowerCase().includes(q) ||
        item.groupLabel.toLowerCase().includes(q) ||
        String(item.hint || "").toLowerCase().includes(q),
    );
  }, [query]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const displayedItems = useMemo(() => {
    return filteredItems.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage,
    );
  }, [filteredItems, currentPage, itemsPerPage]);

  const handleItemsPerPageChange = (newSize) => {
    setItemsPerPage(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [query]);

  useEffect(() => {
    if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    } else if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const setItemFlag = (item, flag) => {
    if (disabled) return;
    const nextPerms = toggleItemAccess(permissions, item, flag);
    onChange(nextPerms);
  };

  const setItemAllFlags = (item, nextVal) => {
    if (disabled) return;
    const nextPerms = setItemAllAccess(permissions, item, nextVal);
    onChange(nextPerms);
  };

  const allPagesOn =
    filteredItems.length > 0 &&
    filteredItems.every((item) => isRowAllOn(permissions, item));

  const setAllPagesFlags = (nextVal) => {
    if (disabled) return;
    let nextPerms = permissions;
    filteredItems.forEach((item) => {
      nextPerms = setItemAllAccess(nextPerms, item, nextVal);
    });
    onChange(nextPerms);
  };

  return (
    <div>
      <div className="d-flex justify-content-end mb-3 flex-wrap gap-2 align-items-center">
        <input
          type="text"
          className={`form-control ${
            buttonTableStyle === "square" ? "rounded-0" : ""
          }`}
          style={{ maxWidth: "260px" }}
          placeholder="Search permissions..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search permissions"
        />
      </div>

      {filteredItems.length === 0 ? (
        <p className="text-muted text-center py-4 mb-0">
          No pages match “{query}”.
        </p>
      ) : (
        <>
          <div className={`table-responsive mb-4 border ${cardClass}`}>
            <table
              className={`table text-nowrap mb-0 align-middle emp-perm-table ${tableClass}`}
            >
              <thead className="text-dark fs-4">
                <tr>
                  <th className="emp-perm-select-col">
                    <Form.Check
                      type="checkbox"
                      id="emp-perm-all-pages"
                      className={`emp-perm-header-check mb-0${allPagesOn ? " is-checked" : ""}`}
                      checked={allPagesOn}
                      disabled={disabled || filteredItems.length === 0}
                      aria-label="Select all page permissions"
                      onChange={() => setAllPagesFlags(!allPagesOn)}
                    />
                  </th>
                  <th>
                    <h6 className="fs-4 fw-semibold mb-0">Pages</h6>
                  </th>
                  <th>
                    <h6 className="fs-4 fw-semibold mb-0">Actions</h6>
                  </th>
                </tr>
              </thead>
              <tbody>
                {displayedItems.map((item) => {
                  const access = getItemAccess(permissions, item);
                  const allOn = isRowAllOn(permissions, item);
                  return (
                    <tr key={item.id}>
                      <td className="emp-perm-select-col">
                        <Form.Check
                          type="checkbox"
                          id={`emp-perm-${item.id}-all`}
                          className={`emp-perm-row-check mb-0${allOn ? " is-checked" : ""}`}
                          checked={allOn}
                          disabled={disabled}
                          aria-label={`${item.pageLabel} all permissions`}
                          onChange={() => setItemAllFlags(item, !allOn)}
                        />
                      </td>
                      <td>
                        <span className="fw-medium text-dark">
                          {item.pageLabel}
                        </span>
                        {item.hint && (
                          <div
                            className="text-muted small"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {item.hint}
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="emp-perm-actions-group">
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-add`}
                            checked={access.hasAdd ? Boolean(access.add) : false}
                            disabled={disabled || !access.hasAdd}
                            label={`${item.pageLabel} add`}
                            caption="Add"
                            onChange={() =>
                              access.hasAdd && setItemFlag(item, "add")
                            }
                          />
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-edit`}
                            checked={access.hasEdit ? Boolean(access.edit) : false}
                            disabled={disabled || !access.hasEdit}
                            label={`${item.pageLabel} edit`}
                            caption="Edit"
                            onChange={() =>
                              access.hasEdit && setItemFlag(item, "edit")
                            }
                          />
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-view`}
                            checked={access.hasView ? Boolean(access.view) : false}
                            disabled={disabled || !access.hasView}
                            label={`${item.pageLabel} view`}
                            caption="View"
                            onChange={() =>
                              access.hasView && setItemFlag(item, "view")
                            }
                          />
                          <AccessCheckbox
                            id={`emp-perm-${item.id}-delete`}
                            checked={
                              access.hasDelete ? Boolean(access.delete) : false
                            }
                            disabled={disabled || !access.hasDelete}
                            label={`${item.pageLabel} delete`}
                            caption="Delete"
                            onChange={() =>
                              access.hasDelete && setItemFlag(item, "delete")
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <Pagination
            totalItems={filteredItems.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            itemsPerPageOptions={[10, 20, 30, 50, 100]}
          />
        </>
      )}
    </div>
  );
}

export default EmployeePermissionPanel;
